import Image from 'next/legacy/image';
import Icon from '@components/atoms/icon';
import {
  BodyRegular,
  BodyRegularBold,
  BodySmallRegular
} from '@components/atoms/typography';

type ReviewCardType = {
  reviewText: string;
  userName: string;
};

const ReviewCard = ({ reviewText, userName }: ReviewCardType) => (
  <div className="p-4 rounded-lg shadow-100 flex flex-col justify-between bg-white">
    <div className="bg-neutral-100 rounded-full w-10 h-10 flex justify-center items-center mb-5">
      <Icon name={'Avatar'} className="text-primary-600 h-6 w-6" />
    </div>
    <div className="mb-3">
      <Image
        src={'/images/trust-pilot-5-stars.png'}
        height={20}
        width={105}
        alt="Fantasy Football Hub five star Trustpilot review"
      />
    </div>
    <BodyRegular className="mb-4">{reviewText}</BodyRegular>
    <span className="border-neutral-300 border-b" />
    <div className="mt-4">
      <BodyRegularBold>{userName}</BodyRegularBold>
      <BodySmallRegular className="text-neutral-600">
        App Store Review
      </BodySmallRegular>
    </div>
  </div>
);

export default ReviewCard;
